<template>
	<div class="contentHome">
		<div class="centerPage">
			<el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
				<el-breadcrumb-item>账号管理</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="formUserInfo">
				<el-form
						ref="baseData"
						class="info"
						:model="baseData"
						label-width="90px"
						label-suffix="："
						:hide-required-asterisk="true"
						:rules="rules">
					<el-upload
							class="avatar-uploader"
							action=""
							:show-file-list="false"
							name="uploadFile"
							:auto-upload="false"
							:on-change='changeUpload'>
						<div :style="'backgroundImage: url('+baseData.headImgPath+')'" class="avatar"></div>
						<span class="uploaderIcon">修改头像</span>
					</el-upload>
					
					<!-- vueCropper 剪裁图片实现-->
					<el-dialog title="图片剪裁" :visible.sync="dialogVisible" :close-on-press-escape="false"
										 :close-on-click-modal="false" append-to-body>
						<div class="cropper-content">
							<div class="cropper" style="text-align:center">
								<vueCropper
										ref="cropper"
										:img="option.img"
										:outputSize="option.size"
										:outputType="option.outputType"
										:info="true"
										:canScale="option.canScale"
										:autoCrop="option.autoCrop"
										:autoCropWidth="option.autoCropWidth"
										:autoCropHeight="option.autoCropHeight"
										:fixedBox="option.fixedBox"
										:fixed="option.fixed"
										:fixedNumber="option.fixedNumber"
										:canMove="option.canMove"
										:canMoveBox="option.canMoveBox"
										:original="option.original"
										:centerBox="option.centerBox"
										:infoTrue="option.infoTrue"
										:full="option.full"
										:enlarge="option.enlarge"
										:mode="option.mode">
								</vueCropper>
							</div>
						</div>
						<div slot="footer" class="dialog-footer">
							<el-button @click="dialogVisible = false">取消</el-button>
							<el-button type="primary" @click="finish" :loading="loading">确认</el-button>
						</div>
					</el-dialog>
					
					<p class="tit">基本信息</p>
					<div class="flex">
						<el-form-item label="真实姓名">
							<el-input v-model="baseData.fullName" readonly></el-input>
						</el-form-item>
						<el-form-item label="性别">
							<span>{{ baseData.gender == 1 ? '男' : baseData.gender == 0 ? '女' : '-' }}</span>
						</el-form-item>
					</div>
					<el-form-item label="英文名" prop="enName">
						<el-input v-model="baseData.enName" readonly clearable style="width: 400px;" maxlength="80"
											placeholder="英文名"></el-input>
					</el-form-item>
					<el-form-item label="所在国家" prop="country">
						<el-input v-model="baseData.country" clearable style="width: 400px;" maxlength="80"
											placeholder="所在国家"></el-input>
					</el-form-item>
					<el-form-item label="所在省(州)" prop="province">
						<el-input v-model="baseData.province" clearable style="width: 400px;" maxlength="80"
											placeholder="所在省份(州)"></el-input>
					</el-form-item>
					<el-form-item label="所在城市" prop="abodeCity">
						<el-input v-model="baseData.abodeCity" clearable style="width: 400px;" maxlength="80"
											placeholder="所在城市"></el-input>
					</el-form-item>
					<el-form-item label="所在区" prop="district">
						<el-input v-model="baseData.district" clearable style="width: 400px;" maxlength="80"
											placeholder="所在区"></el-input>
					</el-form-item>
					<el-form-item label="手机号码" prop="mobile">
						<el-input type="tel" v-model="baseData.mobile " style="width: 400px;" clearable maxlength="11"
											placeholder="手机号码"></el-input>
					</el-form-item>
					<el-form-item label="邮箱账号" prop="email">
						<el-input v-model="baseData.email " style="width: 400px;" clearable maxlength="255"
											placeholder="邮箱账号"></el-input>
					</el-form-item>
					<el-form-item label="咨询专科" prop="skill">
						<el-input v-model="baseData.professional" clearable placeholder="" style="width: 600px" maxlength="255"
											prop="professional"></el-input>
					</el-form-item>
					<el-form-item label="专业擅长" prop="skill">
						<el-input v-model="baseData.skill" clearable placeholder="" maxlength="255" style="width: 600px" prop="skill"></el-input>
					</el-form-item>
					<div class="flex underlyingD">
						<el-form-item label="签名" prop="signature">
							<el-input v-model="baseData.signature" clearable style="width: 600px;" maxlength="255" placeholder="签名"></el-input>
						</el-form-item>
						<el-button @click="updateBaseMethod('baseData')">保存</el-button>
					</div>
				</el-form>
				<el-form ref="accountData" class="info" :model="accountData" label-width="80px" label-suffix="："
								 :hide-required-asterisk="true">
					<p class="tit">账号信息</p>
					<el-form-item label="登录手机">
						<span>{{ accountData.mobile }}</span>
						<el-button type="primary" size="mini" style="background: #567BFF;border-color: #567BFF;margin-left: 8px;"
											 @click="showUpdateMobileModal()">更换
						</el-button>
					</el-form-item>
					<el-form-item label="登录邮箱">
						<span>{{ accountData.email }}</span>
						<el-button type="primary" size="mini" style="background: #567BFF;border-color: #567BFF;margin-left: 8px;"
											 @click="showUpdateEmailModal()">更换
						</el-button>
					</el-form-item>
					<el-form-item label="我的网址">
						<span>{{ website }}{{ baseData.account }}</span>
						<el-tooltip v-if="contactEmail" placement="right" effect="light">
							<div slot="content">修改账户名请联系：{{ contactEmail }}</div>
							<i class="el-icon-question"
								 style="font-size: 20px; color: #999; vertical-align: middle; margin-left: 10px; cursor: pointer;"></i>
						</el-tooltip>
					</el-form-item>
				</el-form>
				<el-form ref="jobData" class="info" :model="jobData" label-width="80px" label-suffix="：" :rules="rules"
								 :hide-required-asterisk="true">
					<p class="tit">职业信息</p>
					<el-form-item label="所在单位" prop="company">
						<el-input v-model="jobData.company" clearable style="width: 400px;" maxlength="255"
											placeholder="所在单位"></el-input>
					</el-form-item>
					<el-form-item label="科室" prop="department">
						<el-input v-model="jobData.department" style="width: 400px;" clearable maxlength="255" placeholder="科室"></el-input>
					</el-form-item>
					<div class="flex underlyingD">
						<el-form-item label="职位" prop="job">
							<el-input v-model="jobData.job" style="width: 400px;" maxlength="255" clearable placeholder="职位"></el-input>
						</el-form-item>
						<el-button @click="updateJob('jobData')">保存</el-button>
					</div>
				</el-form>
				
				<el-form ref="departTagForm" class="info" label-width="80px" label-suffix="：" :hide-required-asterisk="true"
								 @submit.native.prevent>
					<p class="tit">专业科室</p>
					<div class="flex" style="justify-content: space-between;">
						<el-form-item label="科室" prop="department">
							<el-tag
									v-for="(tag,index) in departTag.tags"
									:key="'depart_' + index"
									:disable-transitions="false"
									@close="handleRemoveDepartTag(index)"
									closable>
								{{tag}}
							</el-tag>
							<el-input
									class="input-new-tag"
									v-if="departTag.inputVisible"
									v-model="departTag.inputValue"
									ref="saveDepartTagInput"
									size="small"
                  maxlength="30"
									@keyup.enter.native="handleDepartTagInputConfirm"
									@blur="handleDepartTagInputConfirm">
							</el-input>
							<el-button v-else class="button-new-tag" size="small" @click="showDepartTagInput">新增科室</el-button>
						</el-form-item>
						<el-button class="tag-save-btn" @click="updateDepartTag">保存</el-button>
					</div>
				</el-form>
				
				<el-form ref="languageTagForm" class="info" label-width="80px" label-suffix="：" :hide-required-asterisk="true"
								 @submit.native.prevent>
					<p class="tit">擅长语言</p>
					<div class="flex" style="justify-content: space-between;">
						<el-form-item label="语言" prop="language">
							<el-tag
									v-for="(tag,index) in languageTag.tags"
									:key="'language_' + index"
									:disable-transitions="false"
									@close="handleRemoveLanguageTag(index)"
									closable>
								{{tag}}
							</el-tag>
							<el-input
									class="input-new-tag"
									v-if="languageTag.inputVisible"
									v-model="languageTag.inputValue"
									ref="saveLanguageTagInput"
									size="small"
                  maxlength="30"
									@keyup.enter.native="handleLanguageTagInputConfirm"
									@blur="handleLanguageTagInputConfirm">
							</el-input>
							<el-button v-else class="button-new-tag" size="small" @click="showLanguageTagInput">新增语言</el-button>
						</el-form-item>
						<el-button class="tag-save-btn" @click="updateLanguageTag">保存</el-button>
					</div>
				</el-form>
				
				<el-form ref="baseData1" class="info" :model="baseData" label-width="80px" label-suffix="：" :rules="rules"
								 :hide-required-asterisk="true">
					<p class="tit">专业资质</p>
					<el-form-item label="资质认证" prop="certSource">
						<el-input v-model="baseData.certSource" clearable style="width: 400px;"
											placeholder="资质认证"></el-input>
					</el-form-item>
					<el-form-item label="职称" prop="technicalTitle">
						<el-input v-model="baseData.technicalTitle" clearable style="width: 400px;"
											placeholder="职称"></el-input>
					</el-form-item>
					<div class="flex underlyingD">
						<el-form-item label="教育背景" prop="eduBackground">
							<el-input v-model="baseData.eduBackground" clearable style="width: 400px;"
												placeholder="教育背景"></el-input>
						</el-form-item>
						<el-button @click="updateBaseMethod('baseData1')">保存</el-button>
					</div>
				</el-form>
				<el-form ref="bankData" class="info" :model="bankData" label-width="80px" label-suffix="：" :rules="rules"
								 :hide-required-asterisk="true">
					<p class="tit">账户信息</p>
					<el-form-item label="开户银行" prop="bankName">
						<el-input v-model="bankData.bankName" clearable style="width: 400px;"
											placeholder="开户银行"></el-input>
					</el-form-item>
					<el-form-item label="开户名称" prop="bankAccountName">
						<el-input v-model="bankData.bankAccountName " style="width: 400px;" clearable
											placeholder="开户名称"></el-input>
					</el-form-item>
					<div class="flex underlyingD">
						<el-form-item label="账户号码" prop="bankAccountNo">
							<el-input v-model="bankData.bankAccountNo " style="width: 400px;" clearable
												placeholder="账户号码"></el-input>
						</el-form-item>
						<el-button @click="updateBankMethod('bankData')">保存</el-button>
					</div>
				</el-form>
				<el-form ref="info" class="info" :model="honor">
					<p class="tit">荣誉成就</p>
					<div class="achievement">
						<el-form-item v-for="(item, index) in honors" :key="index" :prop="item">
							<el-input :value="item" style="width: 360px;" readonly></el-input>
							<a href="javascript:;" class="flex" @click.prevent="removeHonor(item)"><img
									src="../../assets/img/deleteAch.png" alt="" width="20"></a>
						</el-form-item>
					</div>
					<div class="flex honor">
						<el-form-item>
							<el-input v-model="newHonor" style="width: 400px;" clearable placeholder="请输入荣誉成就"
												maxlength="80"></el-input>
						</el-form-item>
						<div>
							<el-button @click="addHonor">添加</el-button>
							<el-button class="sava" @click="updateHonorMethod">保存</el-button>
						</div>
					</div>
				</el-form>
				<el-form ref="info" class="info" :model="user" label-width="80px" label-suffix="：">
					<p class="tit">服务类型</p>
					<div class="serviceType">
						<el-checkbox-group v-model="myIndicationId" @change="handleCheckedChange"
															 class="handleCheckedChange">
							<el-checkbox v-for="(item,ind) in allIndicationData" :label="item.id" :key="ind">
								{{ item.cnName }}
							</el-checkbox>
						</el-checkbox-group>
						<div class="honor">
							<el-button class="selectAll">
								<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
														 @change="handleCheckAllChange">
									全选
								</el-checkbox>
							</el-button>
							<el-button class="sava" @click="updateIndicationMethod">
								保存
							</el-button>
						</div>
					</div>
				</el-form>
				<el-form ref="info" class="info">
					<p class="tit">简述</p>
					<div class="underlyingD resume">
						<el-form-item prop="briefDesc">
							<el-input v-model="briefDesc" type="textarea" :autosize="{ minRows: 4, maxRows: 10}"
												style="width: 800px;"
												placeholder="简述"></el-input>
						</el-form-item>
						<el-button @click="updateBrief">保存</el-button>
					</div>
				</el-form>
				<div class="share" @click="shareSet">
					<img src="../../assets/img/share.png" alt="" width="13">分享设置
				</div>
			</div>
		</div>
		
		<!-- 修改手机号码弹窗 start -->
		<update-mobile :curMobile="accountData.mobile" ref="updateMobile"></update-mobile>
		<!-- 修改手机号码弹窗 end -->
		<!-- 修改邮箱弹窗 start -->
		<update-email :curEmail="accountData.email" ref="updateEmail"></update-email>
		<!-- 修改邮箱弹窗 end -->
	
	</div>
</template>

<script>
  import base from '@/api/common';
  // 使用vue-cropper 图片上传组件
  import {VueCropper} from 'vue-cropper';
  import SysConstant from '@/api/system_constant';
  import UpdateMobile from './components/update-mobile';
  import UpdateEmail from './components/update-email';

  export default {
    name: "editInfo",
    components: {
      VueCropper,
      UpdateMobile,
      UpdateEmail
    },
    data() {
      return {
        headImgUploadUrl: base.headImgUploadUrl || '',
        user: {},
        honor: {},
        checkAll: false,//服务类型-全选
        isIndeterminate: true,//服务类型-全选
        resume: '从事心理咨询临床工作30年。以心理咨询疾病诊治为特长。以心理咨询规范化治疗和基因及信息化管理为研究方向。建立建立心理咨询联合降',

        getUserId: '',//当前登录用户的id
        doctorData: {},//医生信息
        //荣誉
        indicationData: {},//咨询专长信息

        baseData: {
          headImgPath: '',//头像
          fullName: '',//真实姓名
          //年龄,暂时不用
          gender: '',//性别
          abodeCity: '',//所在城市
          mobile: '',//手机号码
          email: '',//邮箱账号
          skill: '',//专业
          professional: '', //专业专科
          signature: '',//签名
          account: '',//我的网址
          eduBackground: '',//教育背景
          certSource: '',//资质认证
          technicalTitle: '',//职称
        },//基本信息
        jobData: {
          company: '',//所在单位
          department: '',//科室
          job: '',//职位
        },//职业信息
        bankData: {
          bankName: '',//开户银行
          bankAccountName: '',//开户名称
          bankAccountNo: '',//银行卡号
        },//账户信息
        accountData: {
          mobile: '',//登录手机
          email: ''//登录邮箱
        },//账号信息
        honors: [],//荣誉成就
        newHonor: '',//新增荣誉
        allIndicationData: {},//所有服务类型
        allIndicationId: [],//所有服务类型的id
        myIndicationId: [],//该医生的服务类型id
        briefDesc: '',//简历

        msg: 'Welcome to Your Vue.js App',
        fileImg: '',
        dialogVisible: false,
        // 裁剪组件的基础配置option
        option: {
          img: '', // 裁剪图片的地址
          outputSize: 0.8, // 裁剪生成图片的质量
          outputType: 'jpeg', // 裁剪生成图片的格式
          info: true, // 裁剪框的大小信息
          canScale: true, // 图片是否允许滚轮缩放
          autoCrop: true, // 是否默认生成截图框
          autoCropWidth: 133, // 默认生成截图框宽度
          autoCropHeight: 146, // 默认生成截图框高度
          fixedBox: false, // 固定截图框大小 不允许改变
          fixed: true, // 是否开启截图框宽高固定比例
          fixedNumber: [133, 146], // 截图框的宽高比例
          canMove: true, // 上传图片是否可以移动
          canMoveBox: true, // 截图框能否拖动
          original: false, // 上传图片按照原始比例渲染
          centerBox: true, // 截图框是否被限制在图片里面
          infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
          full: false, // 是否输出原图比例的截图
          enlarge: '1', // 图片根据截图框输出比例倍数
          mode: 'contain' // 图片默认渲染方式
        },
        // 防止重复提交
        loading: false,

        website: location.origin + "/",
        contactEmail: SysConstant.TIPS_CONTACT.EMAIL,

        rules: {
          mobile: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            {min: 11, max: 11, message: '长度为11位', trigger: 'blur'}
          ],
          abodeCity: [
            {required: true, message: '请输入城市', trigger: 'blur'},
            {min: 1, max: 100, message: '长度过长', trigger: 'blur'}
          ],
          email: [
            {required: true, message: '请输入邮箱', trigger: 'blur'},
            {max: 255, message: '长度过长', trigger: 'blur'},
            {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'}
          ],
          skill: [
            {required: true, message: '请输入技能', trigger: 'blur'},
            {max: 80, message: '长度过长', trigger: 'blur'}
          ],
          signature: [
            {required: true, message: '请输入签名', trigger: 'blur'},
            {max: 250, message: '长度过长', trigger: 'blur'}
          ],

          company: [
            {required: true, message: '请输入所在公司/单位/医院', trigger: 'blur'},
            {max: 150, message: '长度过长', trigger: 'blur'}
          ],
          department: [
            {required: true, message: '请输入所在部门', trigger: 'blur'},
            {max: 150, message: '长度过长', trigger: 'blur'}
          ],
          job: [
            {required: true, message: '请输入职位', trigger: 'blur'},
            {max: 150, message: '长度过长', trigger: 'blur'}
          ],

          certSource: [
            {required: true, message: '请输入资质认证', trigger: 'blur'},
            {max: 150, message: '长度过长', trigger: 'blur'}
          ],
          technicalTitle: [
            {required: true, message: '请输入职称', trigger: 'blur'},
            {max: 150, message: '长度过长', trigger: 'blur'}
          ],
          eduBackground: [
            {required: true, message: '请输入教育背景', trigger: 'blur'},
            {max: 150, message: '长度过长', trigger: 'blur'}
          ],

          bankName: [
            {required: true, message: '请输入开户银行', trigger: 'blur'},
            {max: 100, message: '长度过长', trigger: 'blur'}
          ],//开户银行
          bankAccountName: [
            {required: true, message: '请输入开户名称', trigger: 'blur'},
            {max: 100, message: '长度过长', trigger: 'blur'}
          ],//开户名称
          bankAccountNo: [
            {required: true, message: '请输入账户号码', trigger: 'blur'},
            {max: 50, message: '长度过长', trigger: 'blur'}
          ],//银行卡号

          // honors: [
          //     {required: true, message: '请输入所在公司/单位/医院', trigger: 'blur'},
          //     {max: 500, message: '长度过长', trigger: 'blur'}
          // ],

          briefDesc: [{max: 500, message: '长度过长', trigger: 'blur'}],
        },
        departTag: { // 科室信息
          tags: [],
          inputVisible: false,
          inputValue: '',
        },
        languageTag: {
          tags: [],
          inputVisible: false,
          inputValue: '',
        }
      }
    },
    async mounted() {

      let currentUser = await base.utils.getCurrent();//获取当前登录的用户id
      if (currentUser != null) {
        this.getUserId = currentUser.id;
      }
      let that = this;
      that.getDoctorDetail();//获得医生详情信息
      that.getMyIndication();//获取咨询专长
      that.getAllIndication();//服务类型

      // tags: depart
      that.$ajax.get(base.basePath + 'auth/doctor-tags/authorize/department/me').then(res => {
        if (res.data.status === 'success') {
          if (res.data.list && res.data.list.length > 0) {
            $(res.data.list).each((i, o) => {
              that.departTag.tags.push(o.tagName);
            })
          }
        }
      }).catch(err => {
        console.error('department tags load fail: ' + err);
      })
			
			// tags: language
			that.$ajax.get(base.basePath + 'auth/doctor-tags/authorize/language/me').then(res=>{
			  if(res.data.status === 'success'){
			    if(res.data.list && res.data.list.length>0){
            $(res.data.list).each((i, o) => {
              that.languageTag.tags.push(o.tagName);
            })
					}
				}
			}).catch(err=>{
			  console.error('language tags load fail: ' + err)
			});
    },
    methods: {
      showUpdateMobileModal() { // 修改手机弹窗
        //console.log(this.$refs['updateMobile'])
        this.$refs['updateMobile'].showDialog();
      },
      showUpdateEmailModal() { // 修改邮箱弹窗
        this.$refs['updateEmail'].showDialog();
      },
      //上传成功后处理图片地址信息
      handleAvatarSuccess(res, file) {
        // this.user.img = URL.createObjectURL(file.raw);
        // this.user.headImgPath = res.message;
        this.baseData.headImgPath = res.message;
      },
      //添加荣誉
      addHonor() {
        if ($.trim(this.newHonor).length === 0) {
          this.$message.warning("请输入内容");
          return;
        }
        if (this.honors.toString().length < 800) {
          this.honors.push(this.newHonor);
          this.newHonor = ''
        } else {
          this.$message.warning("荣誉过多");
        }

      },
      //删除荣誉
      removeHonor(item) {
        let index = this.honors.indexOf(item);
        if (index !== -1) {
          this.honors.splice(index, 1)
        }
      },
      //服务类型-全选
      handleCheckAllChange(val) {
        this.myIndicationId = val ? this.allIndicationId : [];
        this.isIndeterminate = false;
      },
      //服务类型-选择
      handleCheckedChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.allIndicationId.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.allIndicationId.length;
      },
      //获得医生详情信息
      getDoctorDetail() {
        let that = this;
        this.$ajax
            .get(base.api.doctor.detail)
            .then(function (res) {
              if (res.data.status === 'success') {
                that.doctorData = res.data.data;
                that.baseData = {
                  headImgPath: that.doctorData.headImgPath,
                  fullName: that.doctorData.fullName,//真实姓名
                  enName: that.doctorData.enName,
                  //年龄,暂时不用
                  gender: that.doctorData.gender,//性别
                  country: that.doctorData.country,//所在国家
                  province: that.doctorData.province,//所在省份
                  abodeCity: that.doctorData.abodeCity,//所在城市
                  district: that.doctorData.district,//区
                  mobile: that.doctorData.mobile,//手机号码
                  email: that.doctorData.email,//邮箱账号
                  skill: that.doctorData.skill,//专业擅长
                  professional: that.doctorData.professional,//专业擅长
                  signature: that.doctorData.signature,//签名
                  account: that.doctorData.account,//我的网址
                  eduBackground: that.doctorData.eduBackground,//教育背景
                  certSource: that.doctorData.certSource,//资质认证
                  technicalTitle: that.doctorData.technicalTitle,//职称
                };//处理基本信息
                that.jobData = {
                  company: that.doctorData.company,//所在单位
                  department: that.doctorData.department,//科室
                  job: that.doctorData.job,//职位
                };//处理专业资质
                that.bankData = {
                  bankName: that.doctorData.bankName,//开户银行
                  bankAccountName: that.doctorData.bankAccountName,//开户名称
                  bankAccountNo: that.doctorData.bankAccountNo,//银行卡号
                };//处理账户信息
                that.honors = JSON.parse(res.data.data.honors) || [];//处理荣誉成就,["value1","value2",""]
                that.briefDesc = that.doctorData.briefDesc;//处理简介
                that.accountData = {
                  mobile: that.doctorData.loginMobile,
                  email: that.doctorData.loginEmail
                };//账号信息
              }
            })
      },
      //获取该医生的服务类型
      getMyIndication() {
        let that = this;
        this.$ajax
            .get(base.api.doctor.indicationId.replace("{id}", that.getUserId))
            .then(function (res) {
              if (res.data.status === 'success') {
                that.myIndicationId = res.data.list;
              }
            })
      },
      //获得所有服务类型
      getAllIndication() {
        let vm = this;
        this.$ajax
            .get(base.api.famousDoctor.indication)
            .then(function (res) {
              if (res.data.status === 'success') {
                vm.allIndicationData = res.data.list;
              }
            });
        this.$ajax
            .get(base.api.doctor.allIndicationId)
            .then(function (res) {
              if (res.data.status === 'success') {
                vm.allIndicationId = res.data.list;
              }
            })
      },
      //保存基本信息
      updateBaseMethod(formName) {
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.$ajax
                .post(base.api.doctor.updateBase, that.baseData)
                .then(function (res) {
                  if (res.data.status === "success") {
                    that.$message.success('操作成功');
                    // 替换新头像信息
                    // 1.本地头像数据重置
                    localStorage.setItem('headImg', that.baseData.headImgPath);
                    // 2. 顶部头像替换
                    $("#h_img img").attr('src', that.baseData.headImgPath);
                  } else {
                    that.$message.error(res.data.message);
                  }
                }).catch((err) => {
              console.error(err);
              that.$message.error('操作失败');
            })
          } else {
            this.$message.error("请检查所填字段");
            return false;
          }
        });
      },
      //保存专业资质
      updateJob(formName) {
        let that = this;
        this.$refs['jobData'].validate((valid) => {
          if (valid) {
            that.$ajax.post(base.api.doctor.updateJob, that.jobData).then(function (res) {
              if (res.data.status === "success") {
                that.$message.success('操作成功');
              } else {
                that.$message.error(res.data.message);
              }
            }).catch((err) => {
              console.error(err);
              that.$message.error('操作失败');
            })
          } else {
            this.$message.error("请检查所填字段");
            return false;
          }
        });
      },
      //保存账户信息
      updateBankMethod(formName) {
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.$ajax.post(base.api.doctor.updateBank, that.bankData).then(function (res) {
              if (res.data.status === "success") {
                that.$message.success('操作成功');
              } else {
                that.$message.error(res.data.message);
              }
            }).catch((err) => {
              console.error(err);
              that.$message.error('操作失败');
            })
          } else {
            this.$message.error("请检查所填字段");
            return false;
          }
        });

      },
      //保存荣誉成就
      updateHonorMethod() {
        let that = this;
        this.$ajax
            .post(base.api.doctor.updateHonor, {honors: JSON.stringify(that.honors)})
            .then(function (res) {
              if (res.data.status === "success") {
                that.$message.success('操作成功');
              } else {
                that.$message.error(res.data.message);
              }
            }).catch((err) => {
          console.error(err);
          that.$message.error('操作失败');
        })
      },
      //保存服务类型
      updateIndicationMethod() {
        let that = this;
        this.$ajax.post(base.api.doctor.updateIndication, that.myIndicationId).then(function (res) {
          if (res.data.status === "success") {
            that.$message.success('操作成功');
          } else {
            that.$message.error(res.data.message);
          }
        }).catch((err) => {
          console.error(err);
          that.$message.error('操作失败');
        })
      },
      //保存简历
      updateBrief() {
        let that = this;
        this.$ajax.post(base.api.doctor.updateBrief, {
          briefDesc: that.briefDesc
        }).then(function (res) {
          if (res.data.status === "success") {
            that.$message.success('操作成功');
          } else {
            that.$message.error(res.data.message);
          }
        }).catch((err) => {
          console.error(err);
          that.$message.error('操作失败');
        })
      },


      // 上传按钮 限制图片大小
      changeUpload(file, fileList) {
        const isLt5M = file.size / 1024 / 1024 < 5
        if (!isLt5M) {
          this.$message.error('上传文件大小不能超过 5MB!')
          return false
        }

        // 上传成功后将图片地址赋值给裁剪框显示图片
        this.$nextTick(() => {
          this.option.img = URL.createObjectURL(file.raw);
          this.dialogVisible = true
        })
      },
      // 点击裁剪，这一步是可以拿到处理后的地址
      finish() {
        let that = this;
        // 获取截图的base64 数据
        this.$refs.cropper.getCropData((data) => {
          // do something
          this.loading = true;
          // 把图片上传到服务器
          setTimeout(() => {
            this.loading = false;
            this.dialogVisible = false;
            this.fileImg = data;

            let formData = new FormData();

            let arr = data.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            formData.append('uploadFile', new File([u8arr], 'header.png', {type: mime}));

            this.$ajax.post(base.basePath + 'auth/auth-doctor/authorize/update/headImg', formData)
                .then(function (res) {
                  if (res.data.status === 'success') {
                    that.baseData.headImgPath = res.data.message;
                    // 更新头像
                    that.updateUserHeadImg();
                  } else {
                    that.$message.error("头像上传失败");
                  }
                })
          }, 1000)
        });
      },
      updateUserHeadImg(){
        // 1.本地头像数据重置
        localStorage.setItem('headImg', this.baseData.headImgPath);
        // 2. 顶部头像替换
        $("#h_img img").attr('src', this.baseData.headImgPath);
			},
      shareSet() {
        this.$router.push({name: 'shareSet'})
      },
      handleRemoveDepartTag(index) {
        this.departTag.tags.splice(index, 1);
      },
      showDepartTagInput() {
        this.departTag.inputVisible = true;
        this.$nextTick(() => {
          this.$refs.saveDepartTagInput.$refs.input.focus();
        });
      },
      handleDepartTagInputConfirm() {
        let inputValue = $.trim(this.departTag.inputValue);
        if (inputValue) {
          // 去重复内容
          for(let tag of this.departTag.tags){
            if(tag == inputValue){
              this.$message.warning('科室已存在');
              return;
            }
          }
          this.departTag.tags.push(inputValue);
        }
        this.departTag.inputVisible = false;
        this.departTag.inputValue = '';
      },
      updateDepartTag() {
        let that = this;
        if (that.departTag.tags.length == 0) {
          that.$message.warning('至少填写一个');
          return;
        }
        that.$ajax.post(base.basePath + 'auth/doctor-tags/authorize/department/update', {
          tagNames: that.departTag.tags
        }).then(res => {
          if (res.data.status === 'success') {
            that.$message.success('保存成功');
          } else {
            that.$message.error(res.data.message)
          }
        }).catch(err => {
          console.error(err);
          that.$message.error('保存失败');
        })
      },
      handleRemoveLanguageTag(index){
        this.languageTag.tags.splice(index, 1);
			},
      handleLanguageTagInputConfirm(){
        let inputValue = $.trim(this.languageTag.inputValue);
        if (inputValue) {
          // 去重复内容
					for(let tag of this.languageTag.tags){
					  if(tag == inputValue){
					    this.$message.warning('语言已存在');
					    return;
						}
					}
          this.languageTag.tags.push(inputValue);
        }
        this.languageTag.inputVisible = false;
        this.languageTag.inputValue = '';
			},
      showLanguageTagInput(){
        this.languageTag.inputVisible = true;
        this.$nextTick(() => {
          this.$refs.saveLanguageTagInput.$refs.input.focus();
        });
			},
      updateLanguageTag(){
        let that = this;
        if (that.languageTag.tags.length == 0) {
          that.$message.warning('至少填写一个');
          return;
        }
        that.$ajax.post(base.basePath + 'auth/doctor-tags/authorize/language/update', {
          tagNames: that.languageTag.tags
        }).then(res => {
          if (res.data.status === 'success') {
            that.$message.success('保存成功');
          } else {
            that.$message.error(res.data.message)
          }
        }).catch(err => {
          console.error(err);
          that.$message.error('保存失败');
        })
			},
    },
  }
</script>

<style lang="scss" scoped>
	@import "../../assets/css/personalCenter.scss";
	
	.centerPage {
		display: block;
		
		::v-deep .el-radio__input.is-disabled + span.el-radio__label {
			color: #303139;
		}
		
		.formUserInfo ::v-deep .el-form-item__content .el-input__inner[readonly="readonly"] {
			border: none;
			color: #303139;
		}
		
		.formUserInfo ::v-deep .el-form-item__content .el-input__inner {
			color: #666666;
		}
		
		.honor {
			justify-content: space-between;
			
			.el-form-item {
				margin-bottom: 0;
			}
			
			.el-button {
				height: 27px;
				border: 1px solid #567BFF;
				color: #567BFF;
				background: none;
				padding: 0;
				width: 80px;
				
				&.sava {
					background: #567BFF;
					color: #ffffff;
				}
			}
		}
	}
	
	label.el-form-item__label:before {
		content: '';
	}
	
	/* 截图 */
	/* .cropper-content {} */
	.cropper {
		width: auto;
		height: 320px;
	}
	.tag-save-btn{
		width: 80px;
		height: 27px;
		background: #567BFF;
		border-radius: 2px;
		border: none;
		color: #ffffff;
		padding: 0;
		&:hover{
			background: #567BFF;
			color: #ffffff;
		}
	}
</style>
<style>
	.el-tag + .el-tag {
		margin-left: 10px;
	}
	
	.button-new-tag {
		margin-left: 10px;
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}
	
	.input-new-tag {
		width: 90px;
		margin-left: 10px;
		vertical-align: bottom;
	}
</style>
